import { domAnimation, LazyMotion, m } from 'framer-motion';

type WideLayoutProps = {
  children: React.ReactNode;
  hasContainer?: boolean;
  className?: string;
  content?: boolean;
};

const WideLayout = ({
  children,
  hasContainer = true,
  className,
  content = true
}: WideLayoutProps) => {
  return (
    <LazyMotion features={domAnimation}>
      <m.div
        exit={{ opacity: 0 }}
        initial={{ opacity: 0.1 }}
        animate={{ opacity: 1 }}
      >
        <div
          className={`mx-auto ${
            hasContainer && 'lg:container md:px-4 sm:px-2 lg:px-8'
          } ${className ? className : ''}`}
        >
          <div className="block">
            <div className="col-span-5 sm:col-span-4">
              <section className={`${content ? 'content' : ''}`}>
                {children}
              </section>
            </div>
          </div>
        </div>
      </m.div>
    </LazyMotion>
  );
};

export default WideLayout;
